import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Mobiuscase() {
  return (
    <section className="mobiuscase p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2>Built by us, Crafted for you!</h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="mob_icon">
              <StaticImage
                src="../../../images/landing/software-development/mob_logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={336}
                height={54}
              />
            </div>
            <p>
              Mobius Risk Group is an independent multi-asset risk advisory
              firm, offering appropriate market guidance to manufacturers,
              patrons, and capital market participants.
            </p>
            <Link
              to="/case-studies/mobius"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              View Case Study
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center mt-4 mt-md-0"
          >
            <StaticImage
              src="../../../images/landing/software-development/mobius.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={640}
              height={728}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Mobiuscase;
